import React from 'react';
import { Debounce } from 'lodash-decorators';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { Skeleton, Select, Tooltip, Form, List, Card, Tabs, Menu, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import '../Toolbox.less';
/* import sampleFieldData from '../sampleFieldData.json'; */
import { execFetchSchemaVBQL } from '../../models/vbqlResults/vbqlResultsActions';
import Tool from '../../components/Tool';
import FieldsList from './FieldsList';
import SchemaFieldInspector from './SchemaFieldInspector';

// Temporary code to deal with API differences in the analyst workbench environments.
import { API_MODE, LEGACY } from '../../common/api/config';
import InspectorWarning from './InspectorWarning';

const mapStateToProps = (state, { projectionKey }) => {
  let schema;
  const vbqlResult = (
    R
      .pathOr(
        [],
        ['vbqlResults', projectionKey, 'ids'],
        state,
      )
      .map(id => state.vbqlResults.byId[id])
      .pop()
  );

  if (vbqlResult) {
    schema = (
      [...vbqlResult.data]
        .sort((a, b) => a.name.localeCompare(b.name))
        .reduce((acc, field) => R.assocPath(
          field.name.split(/[.:]/),
          field.type === 'object' ? {} : field.type,
          acc,
        ), {})
    );
  }

  return {
    schema,
    isLoading: !!R.path(['vbqlResults', projectionKey, 'isLoading'], state),
  };
};

const mapDispatchToProps = (dispatch, { projectionKey }) => ({
  getSchema: () => dispatch(execFetchSchemaVBQL(projectionKey)),
});

class Index extends React.Component {
  state = {
    selectedField: null,
    filterTerm: null,
  };

  componentDidMount() {
    const { getSchema } = this.props;
    getSchema();
  }

  handleInspectField = (selectedField) => {
    this.setState({ selectedField: selectedField || null });
  };

  handleDeselectField = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ selectedField: null });
  };

  toggleFilter = () => {
    const { filterTerm } = this.state;
    this.setState({ filterTerm: filterTerm === null ? '' : null });
  };

  @Debounce(200)
  handleApplyFilterTerm = (event) => {
    this.setState({
      filterTerm: event.target.value,
    });
  };

  render() {
    const { selectedField, filterTerm } = this.state;
    const { schema, isLoading, projectionKey } = this.props;

    return (
      <Tool
        title="Schema"
        subTitle="Configured Fields"
        loading={isLoading}
        actions={filterTerm === null && [
          <Tool.Header.Action
            icon="search"
            onClick={this.toggleFilter}
          />,
        ]}
        onFilter={filterTerm !== null && this.handleApplyFilterTerm}
        onCancel={filterTerm !== null && this.toggleFilter}
        subRoute={selectedField && (
          API_MODE === LEGACY
            ? <InspectorWarning />
            : (
              <SchemaFieldInspector
                onBack={this.handleDeselectField}
                projectionKey={`${projectionKey}_FIELD_INSPECTOR`}
                fieldName={selectedField}
                fieldType={R.path(selectedField.split(/[.:]/), schema)}
              />
            )
        )}
      >
        <div style={{ padding: '16px' }}>
          <Tool.Skeleton
            active
            paragraph={{ rows: 10 }}
            title={false}
            loading={isLoading}
          >
            <Tool.Divider>Fields</Tool.Divider>
            <FieldsList
              schema={schema}
              selectedField={selectedField}
              filterTerm={filterTerm}
              onInspect={this.handleInspectField}
            />
          </Tool.Skeleton>
        </div>
      </Tool>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);

/*
 subRoute={(
            <ToolPanel.Route
              title="Schema"
              subTitle="Histogram"
              onBack={() => {}}
            />
          )}
<Card
  bordered={false}
  loading={isLoading}
  cover={
    <Input.Search
      disabled={isLoading}
      placeholder="Filter Fields"
      onChange={e => this.onApplySearchTerm(e.target.value)}
    />
  }
  className="vb-toolbox_content_card"
  bodyStyle={{ padding: '8px' }}
>
  <Skeleton title={false} paragraph={{ rows: 10 }} loading={isLoading}>
    <div style={{ background: '#1A2B3A' }}>
      <CustomTree
        className="vb-toolbox-tree"
        showLine={true}
        showIcon={false}
        selectedKeys={[selectedField]}
        onSelect={keys => this.onSelectField([...keys].pop())}
        expandedKeys={expandedKeys}
        onExpand={this.onExpand}
      >
        {schema && this.renderFields(schema)}
      </CustomTree>
    </div>
  </Skeleton>
</Card>
*/
